module.exports = __webpack_public_path__ + "92a1a42a3d2dcefaaf1d5325f7170022.jpg";